export default __webpack_public_path__ + "static/media/Board1_Preview_Transparent.6cf10054.png";